import { useLayoutEffect, useRef, useState } from "react"

export const ExpandableText = ({ value }) => {
    const [expanded, setExpanded] = useState(false)
    const [canExpand, setCanExpand] = useState(false)
    const textRef = useRef(null)

    useLayoutEffect(() => {
        if (!textRef.current || expanded) return
        setCanExpand(textRef.current.scrollHeight > textRef.current.clientHeight + 1)
    }, [value, expanded])

    if (!value) return "-"

    return (
        <div className={`table-expandable-wrapper${expanded ? " expanded" : ""}${canExpand ? " has-more" : ""}`}>
            <div
                ref={textRef}
                className={expanded ? "table-expandable-text expanded" : "table-expandable-text"}
            >
                {value}
            </div>
            {canExpand && (
                <div className="table-read-more-container">
                    <button
                        type="button"
                        className="table-read-more fw-bolder"
                        onClick={() => setExpanded((current) => !current)}
                    >
                        {expanded ? "Read less" : "Read more"}
                    </button>
                </div>
            )}
        </div>
    )
}
